let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Y4Hb")).then(() => parcelRequire('7ciIH'));